/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_DownloadInputs */

const en_gc_editor_download = /** @type {(inputs: Gc_Editor_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get desktop app`)
};

const zh_gc_editor_download = /** @type {(inputs: Gc_Editor_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载桌面版`)
};

/**
* | output |
* | --- |
* | "Get desktop app" |
*
* @param {Gc_Editor_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_download = /** @type {((inputs?: Gc_Editor_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_download(inputs)
	return zh_gc_editor_download(inputs)
});
export { gc_editor_download as "gc.editor.download" }